module.exports = __webpack_public_path__ + "img/bannerWx.83ffea7b.png";